import { render, staticRenderFns } from "./CustomProviderTariffs.vue?vue&type=template&id=4dc342a1&"
import script from "./CustomProviderTariffs.vue?vue&type=script&lang=ts&"
export * from "./CustomProviderTariffs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports